import "slick-carousel/slick/slick";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import Parallax from "parallax-js";

const introFeatures = () => {
  const mobileBreakpoint = 639;
  const slickFeatures = $(".intro-features");
  const prevArrow = $(
    ".page-section--feature-linking .js-slider-arrow .btn-prev-arrow"
  );
  const nextArrow = $(
    ".page-section--feature-linking .js-slider-arrow .btn-next-arrow"
  );

  if ($(window).width() <= mobileBreakpoint) {
    slickFeatures.on("init reInit afterChange", function(
      event,
      slick,
      currentSlide,
      nextSlide
    ) {
      if (!slick.$dots) {
        return;
      }
      const counter = (currentSlide ? currentSlide : 0) + 1,
        sumCouner = slick.$dots[0].children.length;

      if (counter === 1) {
        prevArrow.addClass("is-disable");
        prevArrow.attr("tabindex", "-1");
        nextArrow.removeClass("is-disable");
        nextArrow.removeAttr("tabindex", "-1");
      } else if (counter === sumCouner) {
        nextArrow.addClass("is-disable");
        nextArrow.attr("tabindex", "-1");
        prevArrow.removeClass("is-disable");
        prevArrow.removeAttr("tabindex", "-1");
      } else {
        nextArrow.removeClass("is-disable");
        nextArrow.removeAttr("tabindex", "-1");
        prevArrow.removeClass("is-disable");
        prevArrow.removeAttr("tabindex", "-1");
      }
    });

    slickFeatures.slick({
      infinite: false,
      slidesToShow: 1,
      speed: 150,
      arrows: false,
      accessibility: true,
      ariaPolite: true,
      dsf: false,
      adaptiveHeight: true,
      dots: true
    });

    nextArrow.click(function(e) {
      e.preventDefault();
      slickFeatures.slick("slickNext");
    });
    prevArrow.click(function(e) {
      e.preventDefault();
      slickFeatures.slick("slickPrev");
    });
  }
};

const initParallaxDecorations = scene => {
  const parallaxInstance = new Parallax(scene[0], {
    pointerEvents: false,
    invertX: false,
    invertY: false,
    relativeInput: false
  });

  parallaxInstance.friction(0.2, 0.2);
};

const initParallaxMobile = () => {
  const tabletBreakpoint = 960;
  if ($(window).width() > tabletBreakpoint) {
    const scene = $(".js-decorations-key-group");

    initParallaxDecorations(scene);
  }
};

const clampTextHandler = () => {
  const tabletWidth = 640;
  const desktopWidth = 960;
  const desktopWidthLg = 1280;

  if ($(window).width() >= tabletWidth) {
    $(".photo-card").each(function() {
      const photoCardTitle = $(this).find(".photo-card__title");
      const photoCardDescription = $(this).find(".photo-card__description");

      const titleSingleRow = 34;
      const titleDobleRow = 65;
      const descriptionFourRows = 190;
      const descriptionFiveRows = 240;

      const sliceHandle = (item = photoCardDescription, count) =>
        item.text().slice(0, count) + "...";

      if ($(window).width() >= desktopWidthLg) {
        photoCardTitle.text().length > titleSingleRow &&
          photoCardDescription.text(
            sliceHandle(photoCardDescription, descriptionFourRows)
          );

        photoCardTitle.text().length > titleDobleRow &&
          photoCardTitle.text(sliceHandle(photoCardTitle, titleDobleRow));

        photoCardDescription.text().length > descriptionFiveRows &&
          photoCardDescription.text(
            sliceHandle(photoCardDescription, descriptionFiveRows)
          );
      } else {
        photoCardDescription.text().length > 220 &&
          photoCardDescription.text(sliceHandle(photoCardDescription, 220));
      }
    });
  }
};

$(document).ready(function() {
  addedLazyLoadImages();
  initWowLibrary();
  introFeatures();
  initParallaxMobile();
  clampTextHandler();
});
